import dayjs from 'dayjs'
import { combineEpics, Epic, ofType } from 'redux-observable'
import { filter, map, withLatestFrom } from 'rxjs'
import {
  isOpenFinRuntime,
  MAIN_WINDOW_NAME
} from '../../containers/OpenFin/helpers'
import { createInvokeEpic } from '../../signalr/createInvokeEpic'
import { addToast } from '../toasts/actions'
import { getCookieConsentDate } from '../userPreferences/selectors'
import {
  fetchUserPermissionsDefinition,
  getWebSettingsDefinition
} from './definition'
import CookieCloseButton from './helpers'

const cookieConsentEpic: Epic = (action$, state$) =>
  action$.pipe(
    ofType('webSettings.setWebSettings'),
    withLatestFrom(state$),
    filter(() => {
      const isOpenFin = isOpenFinRuntime()
      const browserCookie = document.cookie.includes('accepted-cookies')

      // Also check stored date in case user switches browsers
      const userPrefsCookieDate = dayjs(getCookieConsentDate(state$.value))
      const expirationDate = userPrefsCookieDate.add(1, 'year')
      const isValid =
        userPrefsCookieDate.isValid() &&
        userPrefsCookieDate.isBefore(expirationDate)

      return (
        !browserCookie &&
        !isValid &&
        (!isOpenFin || fin.me.identity.name === MAIN_WINDOW_NAME)
      )
    }),
    map(() => {
      return addToast({
        message: 'By using our website you agree to the use of cookies',
        options: {
          position: 'bottom-center',
          toastId: 'cookie-notice',
          type: 'info',
          closeButton: CookieCloseButton,
          autoClose: false
        }
      })
    })
  )

export default combineEpics(
  createInvokeEpic('settings.handleWindowSettings', getWebSettingsDefinition),
  createInvokeEpic(
    'webSettings.fetchUserPermissions',
    fetchUserPermissionsDefinition
  ),
  cookieConsentEpic
)
